import { EventListeners, MinzeElement, Reactive } from "minze";
import { EMAIL_REGEX } from "../../modules/utils";
import { Locale } from "../../modules/locale";
import { SquidexTextLabels } from "../../modules/squidex/labels";

Locale.getInstance().registerKeySet("fr", "newsletter", {
  title: {
    default: `Restez informé·e·s\n sur nos projets et initiatives`,
    foundation: "Infolettre de la Fondation",
    "school-staff": "Infolettre pour le Personnel Scolaire",
  },
  description: {
    default:
      "Nos équipes partagent avec vous les grands constats et les raisons d’utilisation des services de Tel-jeunes. Nos experts de l’adolescence vous informent sur des sujets d’actualités et vous pistent pour vous permettre de soutenir les jeunes qui vous entourent.",
    foundation:
      "Abonnez-vous à notre infolettre pour connaitre l’impact de vos dons et restez à l’affût des nouvelles et activités de la Fondation!",
    "school-staff":
      "Abonnez-vous à notre infolettre pour restez à l’affût des nouvelles et activités de le Personnel Scolaire!",
  },
  noEmailError: "Veuillez saisir votre adresse électronique",
  invalidEmailError: "Adresse électronique invalide",
  placeholder: "Adresse courriel",
  successMessage: "Merci pour votre inscription à l’infolettre.",
});

Locale.getInstance().registerKeySet("en", "newsletter", {
  title: {
    default: `Stay Up to Date\n on our Projects and Initiatives`,
    foundation: "Foundation Newsletter",
    "school-staff": "School Staff Newsletter",
  },
  description: {
    default:
      "Our teams share their recent experiences and the reasons people are using Tel-jeunes’ services. Our experts in adolescence also keep you informed on current issues and provide tips to help you support the young people around you.",
    foundation:
      "Subscribe to our newsletter to learn about the impact of your donations and stay informed about the news and activities of the Foundation!",
    "school-staff":
      "Subscribe to our newsletter to stay informed about the news and activities related to School Staff!",
  },
  noEmailError: "Please enter your email address",
  invalidEmailError: "Invalid email address",
  placeholder: "Email Address",
  successMessage: "Thank you for subscribing to the newsletter.",
});

export class TjNewsletter extends MinzeElement {
  reactive: Reactive = [
    ["error", ""],
    ["email", ""],
    ["submitted", false],
    ["isPopupOpen", false],
  ];

  validateEmail = (email: string, submitting: boolean = false) => {
    this.error = "";
    if (!email && submitting) {
      this.error = SquidexTextLabels.getKey("newsletter.noEmailError");
    }
    if (email && !EMAIL_REGEX.test(email)) {
      this.error = SquidexTextLabels.getKey("newsletter.invalidEmailError");
    }
  };

  triggerEmailValidation = (submitting: boolean = false) => {
    const emailField = this.select("#email-input") as HTMLInputElement;
    const email = emailField?.value;
    this.validateEmail(email, submitting);
    this.email = email;
  };

  // submit = async () => {
  //   const webhookId =
  //     this.dataSiteSection === "school-staff" ? "3lhuj8m" : "3lh3t7t";
  //   this.triggerEmailValidation(true);
  //   if (!this.error) {
  //     const response = await submitForm(webhookId, { email: this.email });
  //     if (response.status === "success") {
  //       this.submitted = true;
  //       this.email = "";
  //     }
  //   } else {
  //     this.submitted = false;
  //   }
  // };
  handleSubmit = () => {
    this.triggerEmailValidation(true)   
    if (!this.error && this.email) {
      this.isPopupOpen = true
      document.body.style.overflow = "hidden";
    }
  }
  handleClosePopup = () => {
    this.isPopupOpen = false
    document.body.style.overflow = "auto";
  }
  renderPopupFr = () => /*html*/ `
    <div class="popup-wrapper">
      <div class="popup-overlay"></div>
      <div class="popup-content">
        <span id="close-popup-button" name="close-popup-button">&times;</span>
        <div id="mc_embed_shell">
          <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css">
          <style type="text/css">
          #mc_embed_signup{background:#fff;clear:left; font:16px;}
          /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
            We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
          </style>
          <div id="mc_embed_signup">
            <form action="https://fondationteljeunes.us9.list-manage.com/subscribe/post?u=e81547de8039ea64383572019&amp;id=c64feb0b93&amp;f_id=00cdd4e3f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank">
                <div id="mc_embed_signup_scroll"><h2>Je veux m'inscrire à l'infolettre Tel-jeunes</h2>
                  <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
                  <div class="mc-field-group"><label for="mce-EMAIL">Adresse courriel <span class="asterisk">*</span></label><input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" value="${this.email}"><span id="mce-EMAIL-HELPERTEXT" class="helper_text">Merci d'entrer votre courriel ici </span></div><div class="mc-field-group"><label for="mce-FNAME">Prénom </label><input type="text" name="FNAME" class=" text" id="mce-FNAME" value=""></div><div class="mc-field-group"><label for="mce-LNAME">Nom de famille </label><input type="text" name="LNAME" class=" text" id="mce-LNAME" value=""></div><div class="mc-field-group"><label for="mce-MMERGE8">Établissement </label><input type="text" name="MMERGE8" class=" text" id="mce-MMERGE8" value=""></div><div class="mc-field-group input-group"><strong>Type d'infolettre </strong><ul><li><input type="checkbox" name="group[54057][1]" id="mce-group[54057]-54057-0" value=""><label for="mce-group[54057]-54057-0">Personnel scolaire</label></li><li><input type="checkbox" name="group[54057][2]" id="mce-group[54057]-54057-1" value=""><label for="mce-group[54057]-54057-1">Fondation Tel-jeunes</label></li></ul></div>
                <div id="mce-responses" class="clear">
                  <div class="response" id="mce-error-response" style="display: none;"></div>
                  <div class="response" id="mce-success-response" style="display: none;"></div>
                </div><div aria-hidden="true" style="position: absolute; left: -5000px;"><input type="text" name="b_e81547de8039ea64383572019_c64feb0b93" tabindex="-1" value=""></div><div class="clear"><input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button" value="S'inscrire"></div>
            </div>
            </form>
          </div>
          <script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script><script type="text/javascript">(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[8]='MMERGE8';ftypes[8]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[6]='MMERGE6';ftypes[6]='text';fnames[7]='MMERGE7';ftypes[7]='text';fnames[5]='ADRESSECOU';ftypes[5]='text';/*
          * Translated default messages for the $ validation plugin.
          * Locale: FR
          */
          $.extend($.validator.messages, {
            required: "Ce champ est requis.",
            remote: "Veuillez remplir ce champ pour continuer.",
            email: "Veuillez entrer une adresse email valide.",
            url: "Veuillez entrer une URL valide.",
            date: "Veuillez entrer une date valide.",
            dateISO: "Veuillez entrer une date valide (ISO).",
            number: "Veuillez entrer un nombre valide.",
            digits: "Veuillez entrer (seulement) une valeur numérique.",
            creditcard: "Veuillez entrer un numéro de carte de crédit valide.",
            equalTo: "Veuillez entrer une nouvelle fois la même valeur.",
            accept: "Veuillez entrer une valeur avec une extension valide.",
            maxlength: $.validator.format("Veuillez ne pas entrer plus de {0} caractères."),
            minlength: $.validator.format("Veuillez entrer au moins {0} caractères."),
            rangelength: $.validator.format("Veuillez entrer entre {0} et {1} caractères."),
            range: $.validator.format("Veuillez entrer une valeur entre {0} et {1}."),
            max: $.validator.format("Veuillez entrer une valeur inférieure ou égale à {0}."),
            min: $.validator.format("Veuillez entrer une valeur supérieure ou égale à {0}.")
          });}(jQuery));var $mcj = jQuery.noConflict(true);</script>
        </div>
      </div>
    </div>
  `
  renderPopupEn = () => /*html*/ `
    <div class="popup-wrapper">
      <div class="popup-overlay"></div>
      <div class="popup-content">
        <span id="close-popup-button" name="close-popup-button">&times;</span>
        <div id="mc_embed_shell">
          <link href="//cdn-images.mailchimp.com/embedcode/classic-061523.css" rel="stylesheet" type="text/css" />
          <style type="text/css">
            #mc_embed_signup {
              background: #fff;
              clear: left;
              font: 16px;
            }
            /* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
              We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
          </style>
          <div id="mc_embed_signup">
            <form
              action="https://fondationteljeunes.us9.list-manage.com/subscribe/post?u=e81547de8039ea64383572019&amp;id=c64feb0b93&amp;f_id=00cdd4e3f0"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_blank"
            >
              <div id="mc_embed_signup_scroll">
                <h2>I want to subscribe to the Tel-jeunes newsletter</h2>
                <div class="indicates-required"><span class="asterisk">*</span> indicates "required"</div>
                <div class="mc-field-group">
                  <label for="mce-EMAIL">Email address <span class="asterisk">*</span></label
                  ><input type="email" name="EMAIL" class="required email" id="mce-EMAIL" required="" value="" /><span id="mce-EMAIL-HELPERTEXT" class="helper_text"
                    >Please enter your email here
                  </span>
                </div>
                <div class="mc-field-group"><label for="mce-FNAME">First name </label><input type="text" name="FNAME" class="text" id="mce-FNAME" value="" /></div>
                <div class="mc-field-group"><label for="mce-LNAME">Last name </label><input type="text" name="LNAME" class="text" id="mce-LNAME" value="" /></div>
                <div class="mc-field-group input-group">
                  <strong>Type of newsletter </strong>
                  <ul>
                    <li>
                      <input type="checkbox" name="group[54057][1]" id="mce-group[54057]-54057-0" value="" /><label for="mce-group[54057]-54057-0"> School staff</label>
                    </li>
                    <li>
                      <input type="checkbox" name="group[54057][2]" id="mce-group[54057]-54057-1" value="" /><label for="mce-group[54057]-54057-1"
                        > Tel-jeunes Foundation</label>
                    </li>
                  </ul>
                </div>
                <div class="mc-field-group">
                  <label for="mce-MMERGE8">Institution </label><input type="text" name="MMERGE8" class="text" id="mce-MMERGE8" value="" />
                </div>
                <div id="mce-responses" class="clear">
                  <div class="response" id="mce-error-response" style="display: none"></div>
                  <div class="response" id="mce-success-response" style="display: none"></div>
                </div>
                <div aria-hidden="true" style="position: absolute; left: -5000px">
                  <input type="text" name="b_e81547de8039ea64383572019_c64feb0b93" tabindex="-1" value="" />
                </div>
                <div class="clear"><input type="submit" name="subscribe" id="mc-embedded-subscribe" class="button" value="Subscribe" /></div>
              </div>
            </form>
          </div>
          <script type="text/javascript" src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script>
          <script type="text/javascript">
            (function ($) {
              window.fnames = new Array();
              window.ftypes = new Array();
              fnames[0] = 'EMAIL';
              ftypes[0] = 'email';
              fnames[1] = 'FNAME';
              ftypes[1] = 'text';
              fnames[2] = 'LNAME';
              ftypes[2] = 'text';
              fnames[6] = 'MMERGE6';
              ftypes[6] = 'text';
              fnames[8] = 'MMERGE8';
              ftypes[8] = 'text';
              fnames[3] = 'ADDRESS';
              ftypes[3] = 'address';
              fnames[4] = 'PHONE';
              ftypes[4] = 'phone';
              fnames[7] = 'MMERGE7';
              ftypes[7] = 'text';
              fnames[5] = 'ADRESSECOU';
              ftypes[5] = 'text';
              /*
              * Translated default messages for the $ validation plugin.
              * Locale: EN
              */
              $.extend($.validator.messages, {
                required: 'This field is required.',
                remote: 'Please fill out this field to continue.',
                email: 'Please enter a valid email address.',
                url: 'Please enter a valid URL.',
                date: 'Please enter a valid date.',
                dateISO: 'Please enter a valid date (ISO).',
                number: 'Please enter a valid number.',
                digits: 'Please enter only numeric values.',
                creditcard: 'Please enter a valid credit card number.',
                equalTo: 'Please enter the same value again.',
                accept: 'Please enter a value with a valid extension.',
                maxlength: $.validator.format('Please do not enter more than {0} characters.'),
                minlength: $.validator.format('Please enter at least {0} characters.'),
                rangelength: $.validator.format('Please enter a value between {0} and {1} characters long.'),
                range: $.validator.format('Please enter a value between {0} and {1}.'),
                max: $.validator.format('Please enter a value less than or equal to {0}.'),
                min: $.validator.format('Please enter a value greater than or equal to {0}.'),
              });
            })(jQuery);
            var $mcj = jQuery.noConflict(true);
          </script>
        </div>
      </div>
    </div>
  `
  
  html = () => /* html */ `
    ${this.isPopupOpen ? Locale.getInstance().getLanguage() === 'fr' ? this.renderPopupFr() : this.renderPopupEn() : ''}
    <div class="newsletter-wrapper">
      <div class="newsletter-title">
        <div>${SquidexTextLabels.getKey(
          'newsletter.title.default'
        )}
        </div>
      </div>
      <div class="newsletter-subtitle">${SquidexTextLabels.getKey('newsletter.description.default')}</div>
      <div class="email-input-wrapper">
        <input
          type="text"
          placeholder="${SquidexTextLabels.getKey("newsletter.placeholder")}"
          id="email-input"
          class="email-input"
          value="${this.email}"
        />
        <button id="submit">${SquidexTextLabels.getKey("newsletter.submit")}</button>
      </div>
      <div class="error-text">${this.error}</div>         
      <div class="disclaimer-text">${SquidexTextLabels.getKey("newsletter.disclaimer")}</div>
    </div>
  `;

  css = () => `
    :host {
      background: #ffffff;
      color: #133762;
      padding: 32px;
      border-radius: 3rem;
    }
    .newsletter-title {
      font-size: 1.5rem;
      line-height: 1.2
    }
    .newsletter-subtitle {
      font-size: 0.875rem;
      margin: 12px 0;
    }
    .email-input-wrapper {
      display: flex;
      gap: 16px;
    }
    .email-input {
      border: 1px solid #133762;
      padding: 10px;
      font-size: 1rem;
      width: 100%;
      border-radius: 0.5rem;
    }
    .email-input::placeholder {
      color: #133762;
      font-size: 1rem;
    }
    .error-text {
      color: #ff0000;
      font-size: 0.875;
      margin-top: 4px;
    }
    #submit{
      background: #133762;
      color: #ffffff;
      padding: 10px 20px;
      border: none;
      border-radius: 0.5rem;
      cursor: pointer;
    }

    .disclaimer-text {
      margin-top: 12px;
      font-size: 0.75rem;
      font-style: italic;
    }
    .popup-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .popup-overlay{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.30);
    }
    .popup-content {
      background: #ffffff;
      padding: 40px 32px 32px 32px;
      position: absolute;
      border-radius: 1rem;
    }
    #close-popup-button {
      color: #133762;
      font-size: 28px;
      font-weight: bold;
      position: absolute;
      top: 20px;
      right: 20px;
    }
    #close-popup-button:hover,
    #close-popup-button:focus {
      color: #aaaaaa;
      text-decoration: none;
      cursor: pointer;
    }
  `;

  eventListeners: EventListeners = [
    ["#close-popup-button", "click", this.handleClosePopup],
    [".popup-overlay", "click", this.handleClosePopup],
    ["#submit", "click", this.handleSubmit],
    [
      "#email-input",
      "change",
      () => {
        if (this.error) this.triggerEmailValidation();
      },
    ],
  ];
}
